import type { ReactNode } from "react";

export type Citation = {
	id: number;
	label: string;
};

export function ChatMessage({
	role,
	content,
	citations,
}: {
	role: "user" | "ai";
	content: ReactNode;
	citations?: Citation[];
}) {
	return (
		<div className="flex flex-col gap-1">
			<span className="text-cv-fg-muted text-[9px] font-semibold tracking-[0.1em] uppercase">
				{role === "user" ? "You" : "Clearvoid"}
			</span>
			<div
				className={`rounded-md border px-3 py-2 text-xs leading-relaxed ${
					role === "user"
						? "border-cv-bdr-mid bg-cv-bg-elevated text-cv-fg"
						: "border-cv-accent-border bg-cv-accent-glow text-cv-fg-sec"
				}`}
			>
				{content}
				{citations && citations.length > 0 && (
					<div className="mt-2.5 flex flex-col gap-1">
						{citations.map((c) => (
							<div
								key={c.id}
								className="bg-cv-accent-badge text-cv-accent rounded px-2 py-1 text-[9px] font-medium"
							>
								<span className="mr-1.5 font-bold">{c.id}</span>
								{c.label}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
}
